import React, {Component} from 'react'
import CustomFieldDefinitionEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class CustomFieldDefinitionEdit extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            form: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        const definitionId = this.props.match.params.definitionId
        AppContext.getApiClient().get('/custom-field-definitions/' + definitionId).then(definition => {
            const labelForm = <CustomFieldDefinitionEditForm value={definition} />
            this.setState({
                form: labelForm
            })
        })
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        )
    }
}

export default CustomFieldDefinitionEdit


// WEBPACK FOOTER //
// ./src/custom-field/edit.component.jsx